module.exports = __webpack_public_path__ + "static/media/app.940322cb.svg";